import { createBrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
import NetaList from "./pages/Neta/List";
import NewsDetails from "./pages/NewsDetails.js";
import ErrorBoundary from "./pages/ErrorPage";
import Questions from "./pages/Questions";
import NetaDetails from "./pages/Neta/Details";
import Answers from "./pages/Answers";
import Layout from "./components/Layout/Layout";
import News from "./pages/News";
import Petition from "./pages/Petition";
import PetitionDetails from "./pages/PetitionDetails";
import Registration from "./pages/Registration";
import AuthLayout from "./components/AuthLayout/AuthLayout";
import Login from "./pages/Login";
import AdminLayout from "./components/Admin/Layout/AdminLayout";
import Deshboard from "./pages/Admin/Deshboard";
import DivisionList from "./pages/Admin/Division";
import District from "./pages/Admin/District";
import Upazila from "./pages/Admin/Upazila";
import Ambassadors from "./pages/Ambassadors";
import Profile from "./pages/Profile";
import ProtectedRoute from "./utils/ProtectedRoute";
import NetaSelectForm from "./components/Layout/NetaSelectForm";
import UserList from "./pages/Admin/User";
import AmbassadorUsers from "./pages/Admin/AmbassadorUsers";
import ForgetPassword from "./pages/ForgetPassword";
import PasswordReset from "./pages/PasswordReset";
import CreateNeta from "./pages/Admin/Neta/Create";
import PublicProfile from "./pages/PublicProfile";
import PetitionCreate from "./pages/PetitionCreate";
import PetitionEdit from "./pages/PetitionEdit";
import NetaUserList from "./pages/Admin/Neta";
import NetaEdit from "./pages/Admin/Neta/NetaEdit";
import NetaVideos from "./pages/Admin/NetaVideos";
import CreateNetaVideos from "./pages/Admin/NetaVideos/Create";
import NetaVideosEdit from "./pages/Admin/NetaVideos/Edit";
import AdminNetaDetails from "./pages/Admin/Neta/Details";

export const RouteApp = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/neta/list",
        element: <NetaList />,
      },
      {
        path: "/neta/details/:id",
        element: <NetaDetails />,
      },
      {
        path: "/news/details/:id",
        element: <NewsDetails />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/questions/list",
        element: <Questions />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/answers/list",
        element: <Answers />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/news/list",
        element: <News />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/ambassadors/list",
        element: <Ambassadors />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/petition",
        element: <Petition />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/petition/edit/:id",
        element: <PetitionEdit />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/petition/details/:id",
        element: <PetitionDetails />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/petition/create",
        element: <PetitionCreate />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/public-profile",
        element: <PublicProfile />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/neta/select",
        element: (
          <ProtectedRoute>
            <NetaSelectForm />
          </ProtectedRoute>
        ),
        errorElement: <ErrorBoundary />,
      },
    ],
  },
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/registration",
        element: <Registration />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/login",
        element: <Login />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/forget-password",
        element: <ForgetPassword />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/password-reset",
        element: <PasswordReset />,
        errorElement: <ErrorBoundary />,
      },
    ],
  },
  {
    element: <AdminLayout />,
    children: [
      {
        path: "/admin",
        element: <Deshboard />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/division",
        element: <DivisionList />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/district",
        element: <District />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/upazila",
        element: <Upazila />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/user",
        element: <UserList />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/user/ambassador",
        element: <AmbassadorUsers />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/user/neta",
        element: <NetaUserList />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/user/neta/details/:id",
        element: <AdminNetaDetails />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/neta/create",
        element: <CreateNeta />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/neta/edit/:id",
        element: <NetaEdit />,
        errorElement: <ErrorBoundary />,
      },

      {
        path: "/admin/user/neta/videos",
        element: <NetaVideos />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/user/neta/videos/create",
        element: <CreateNetaVideos />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/admin/neta/videos/edit/:id",
        element: <NetaVideosEdit />,
        errorElement: <ErrorBoundary />,
      },
    ],
  },
]);
